/**
 * @flow
 */

import React, { useState, useCallback } from 'react';
import { Modal, MasterTypeIcon } from '../../../../components';
import { property } from 'lodash';

import Navigation from './Navigation';
import PersonalInformation from '../../containers/details/PersonalInformation';
import Appointments from './Appointments';

import type { ModalDialog, Master } from '../../../../type';

type MasterDetailsProps = {
    master: Master,
    tab: string,
} & ModalDialog;

function MasterDetails({ master, trigger, onClose, open, tab }: MasterDetailsProps) {
    const [selectedItem, setSelectedItem] = useState(tab || 'personalInformation');

    const onItemClick = useCallback((e, { name }) => {
        setSelectedItem(name);
    }, []);

    return (
        <Modal onClose={onClose} open={open} trigger={trigger}>
            <Modal.Header>
                <MasterTypeIcon
                    name={`${master.firstName} ${master.lastName}`}
                    type={property(['serviceGroups', '0', 'type'])(master)}
                />
                {master.firstName} {master.lastName}
            </Modal.Header>
            <Navigation selectedItem={selectedItem} onItemClick={onItemClick} />
            {selectedItem === 'personalInformation' && (
                <PersonalInformation
                    master={master}
                    onClose={onClose}
                    open={open}
                />
            )}
            {selectedItem === 'appointments' && <Appointments master={master} />}
        </Modal>
    );
}

export default MasterDetails;
